module.exports = __webpack_public_path__ + "img/brottskarta.461a164d.png";